// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const IframeRedirect = () => {
  if (typeof window !== 'undefined') {
    const { pathname, search } = window.location;
    window.location.replace(`${pathname}/form${search}`);
  }
  return null;
};

const HardReload = () => {
  if (typeof window !== 'undefined') {
    const navEntry = performance?.getEntriesByType?.('navigation')?.[0];
    const navType = navEntry?.type ?? performance?.navigation?.type;

    // Check if we already tried reloading to prevent an infinite loop
    // 'reload' or 1 means the page was already refreshed
    const alreadyReloaded = navType === 'reload' || navType === 1;

    if (!alreadyReloaded) {
      window.location.reload();
    }
  }
  return null;
};

const ssr = typeof window === 'undefined' || import.meta.env.SSR;

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.NationalService = (await import('./views/national/NationalService')).NationalService;
    Components.NationalForm = (await import('./views/national/NationalForm')).NationalForm;
    Components.NationalContact = (await import('./views/national/NationalContact')).NationalContact;
    Components.NationalReviews = (await import('./views/national/NationalReviews')).NationalReviews;
    Components.PageConfirmation = (await import('./pages/PageConfirmation')).default;
    Components.HubService = (await import('./views/hub/HubService')).HubService;
    Components.LocalService = (await import('./views/local/LocalService')).LocalService;
    Components.LocalForm = (await import('./views/local/LocalForm')).LocalForm;
    Components.LocalReviews = (await import('./views/local/LocalReviews')).LocalReviews;
    Components.LocalProjects = (await import('./views/local/LocalProjects')).LocalProjects;
    Components.IframeForm = (await import('./views/iframe/IframeForm')).IframeForm;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages = {}) => ({
  nationalForm: {
    name: 'NationalForm',
    componentName: 'NationalForm',
    chunk: () => import('./views/national/NationalForm'),
    get component() {
      return ssr
        ? serverPages.NationalForm
        : currentRouteName === 'NationalForm'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.NationalForm })));
    },
    path: '/:context?/:contentPV?/services/c/:slug/:serviceId/form',
    prefetch: [],
    channel: null,
    varnish: false,
  },
  nationalContact: {
    name: 'NationalContact',
    componentName: 'NationalContact',
    chunk: () => import('./views/national/NationalContact'),
    get component() {
      return ssr
        ? serverPages.NationalContact
        : currentRouteName === 'NationalContact'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.NationalContact })));
    },
    path: '/:context?/:contentPV?/services/c/:slug/:serviceId/contact',
    prefetch: [],
    channel: null,
    varnish: false,
  },
  nationalReviews: {
    name: 'NationalReviews',
    componentName: 'NationalReviews',
    chunk: () => import('./views/national/NationalReviews'),
    get component() {
      return ssr
        ? serverPages.NationalReviews
        : currentRouteName === 'NationalReviews'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.NationalReviews })));
    },
    path: '/:context?/:contentPV?/services/c/:slug/:serviceId/reviews/page/:page',
    prefetch: [],
    channel: null,
    varnish: false,
  },
  nationalServiceConfirmation: {
    name: 'PageConfirmation',
    componentName: 'PageConfirmation',
    chunk: () => import('./pages/PageConfirmation'),
    get component() {
      return ssr
        ? serverPages.PageConfirmation
        : currentRouteName === 'PageConfirmation'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.default })));
    },
    path: '/:context?/:contentPV?/services/c/:slug/:serviceId/confirmation/:orderId',
    prefetch: [],
    channel: null,
    varnish: false,
  },
  nationalService: {
    name: 'NationalService',
    componentName: 'NationalService',
    chunk: () => import('./views/national/NationalService'),
    get component() {
      return ssr
        ? serverPages.NationalService
        : currentRouteName === 'NationalService'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.NationalService })));
    },
    path: '/:context?/:contentPV?/services/c/:slug/:serviceId',
    prefetch: [],
    channel: null,
    varnish: false,
  },
  hubService: {
    name: 'HubService',
    componentName: 'HubService',
    chunk: () => import('./views/hub/HubService'),
    get component() {
      return ssr
        ? serverPages.HubService
        : currentRouteName === 'HubService'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.HubService })));
    },
    path: '/:context?/:contentPV?/services/h/:slug',
    prefetch: [],
    channel: null,
    varnish: false,
  },
  localForm: {
    name: 'LocalForm',
    componentName: 'LocalForm',
    chunk: () => import('./views/local/LocalForm'),
    get component() {
      return ssr
        ? serverPages.LocalForm
        : currentRouteName === 'LocalForm'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.LocalForm })));
    },
    path: '/:context?/:contentPV?/services/l/:state/:city/:slug/:serviceId/form',
    prefetch: [],
    channel: null,
    varnish: false,
  },
  localReviews: {
    name: 'LocalReviews',
    componentName: 'LocalReviews',
    chunk: () => import('./views/local/LocalReviews'),
    get component() {
      return ssr
        ? serverPages.LocalReviews
        : currentRouteName === 'LocalReviews'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.LocalReviews })));
    },
    path: '/:context?/:contentPV?/services/l/:state/:city/:slug/:serviceId/reviews/page/:page',
    prefetch: [],
    channel: null,
    varnish: false,
  },
  localProjects: {
    name: 'LocalProjects',
    componentName: 'LocalProjects',
    chunk: () => import('./views/local/LocalProjects'),
    get component() {
      return ssr
        ? serverPages.LocalProjects
        : currentRouteName === 'LocalProjects'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.LocalProjects })));
    },
    path: '/:context?/:contentPV?/services/l/:state/:city/:slug/:serviceId/projects/page/:page',
    prefetch: [],
    channel: null,
    varnish: false,
  },
  localServiceConfirmation: {
    name: 'PageConfirmation',
    componentName: 'PageConfirmation',
    chunk: () => import('./pages/PageConfirmation'),
    get component() {
      return ssr
        ? serverPages.PageConfirmation
        : currentRouteName === 'PageConfirmation'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.default })));
    },
    path: '/:context?/:contentPV?/services/l/:state/:city/:slug/:serviceId/confirmation/:orderId',
    prefetch: [],
    channel: null,
    varnish: false,
  },
  localService: {
    name: 'LocalService',
    componentName: 'LocalService',
    chunk: () => import('./views/local/LocalService'),
    get component() {
      return ssr
        ? serverPages.LocalService
        : currentRouteName === 'LocalService'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.LocalService })));
    },
    path: '/:context?/:contentPV?/services/l/:state/:city/:slug/:serviceId',
    prefetch: [],
    channel: null,
    varnish: false,
  },
  iframeForm: {
    name: 'IframeForm',
    componentName: 'IframeForm',
    chunk: () => import('./views/iframe/IframeForm'),
    get component() {
      return ssr
        ? serverPages.IframeForm
        : currentRouteName === 'IframeForm'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.IframeForm })));
    },
    path: '/:context?/:contentPV?/services/i/:slug/:serviceId/form',
    prefetch: [],
    channel: null,
    varnish: false,
  },
  iframeServiceConfirmation: {
    name: 'PageConfirmation',
    componentName: 'PageConfirmation',
    chunk: () => import('./pages/PageConfirmation'),
    get component() {
      return ssr
        ? serverPages.PageConfirmation
        : currentRouteName === 'PageConfirmation'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.default })));
    },
    path: '/:context?/:contentPV?/services/i/:slug/:serviceId/confirmation/:orderId',
    prefetch: [],
    channel: null,
    varnish: false,
  },
  iframeService: {
    name: 'IframeService',
    componentName: 'IframeService',
    chunk: () => Promise.resolve({ IframeService: IframeRedirect }),
    component: IframeRedirect,
    path: '/:context?/:contentPV?/services/i/:slug/:serviceId',
    prefetch: [],
    channel: null,
    varnish: false,
  },
  // SAFETY NET: This catches /reviews and any other unmigrated sub-paths
  unmigratedRoutes: {
    name: 'UnmigratedPath',
    componentName: 'UnmigratedPath',
    component: HardReload,
    path: '*',
    prefetch: [],
    channel: null,
    varnish: false,
  }
});
